import { render, staticRenderFns } from "./ChannelsHero.vue?vue&type=template&id=35c45ffa"
import script from "./ChannelsHero.vue?vue&type=script&lang=js"
export * from "./ChannelsHero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports